/** Canonical entitlement feature flag keys (must match playhouse-server enforcement). */
export const FEATURE_KEYS = {
  VISITS_QR_CODE: 'visits.qr_code',
  PRICING_HOUR_RANGES: 'pricing.hour_ranges',
  DISCOUNTS_ADVANCED: 'discounts.advanced',
  DISCOUNTS_IMPORT: 'discounts.import',
  DISCOUNTS_USAGE_REPORT: 'discounts.usage_report',
  DISCOUNTS_CUSTOMER_SPECIFIC: 'discounts.customer_specific',
  DISCOUNTS_HOUR_RANGES: 'discounts.hour_ranges',
  SALES_REPORTS_TIME_BASED_REVENUE: 'sales_reports.time_based_revenue',
  SALES_REPORTS_VISITS: 'sales_reports.visits',
  SALES_REPORTS_FILTER_BY_STAFF: 'sales_reports.filter_by_staff',
  UTILITIES_ENABLED: 'utilities.enabled',
  UTILITIES_INTEGRATIONS: 'utilities.integrations',
  THEMES_DARK: 'themes.dark',
  CUSTOMERS_CREDITS: 'customers.credits',
  CUSTOMERS_IMPORT: 'customers.import',
  GIFTCARDS_ENABLED: 'giftcards.enabled',
  MANAGEMENT_AUDIT_LOGS: 'management.audit_logs',
  MANAGEMENT_MANAGER_ROLE: 'management.manager_role',
  SUPPORT_PRIORITIES: 'support.priorities',
  SUPPORT_SLA: 'support.sla',
};

/** Canonical entitlement limit keys (must match playhouse-server enforcement). */
export const LIMIT_KEYS = {
  PRICING_MAX_PLANS: 'pricing.max_plans',
  PRICING_MAX_TIERS_PER_PLAN: 'pricing.max_tiers_per_plan',
  PRICING_MAX_STEPS_PER_PLAN: 'pricing.max_steps_per_plan',
  DISCOUNTS_MAX_ACTIVE: 'discounts.max_active',
  UTILITIES_MAX_SETS: 'utilities.max_sets',
  UTILITIES_MAX_ITEMS: 'utilities.max_items',
  MANAGEMENT_MAX_USERS: 'management.max_users',
  CUSTOMERS_MAX_IMPORT_BATCH: 'customers.max_import_batch',
  BRANCHES_MAX_BRANCHES: 'branches.max_branches',
  SUPPORT_MAX_ATTACHMENTS_PER_TICKET: 'support.max_attachments_per_ticket',
  SUPPORT_MAX_ATTACHMENT_SIZE_MB: 'support.max_attachment_size_mb',
};

/** Legacy web flag names mapped to canonical server keys. */
export const LEGACY_FEATURE_ALIASES = {
  advanced_config: FEATURE_KEYS.UTILITIES_ENABLED,
};
